//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ClassesLoaded } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CustomSelect from "components/Select/Select.jsx";

//icons
import Close from "@material-ui/icons/Close";

import ClassEditor from "components/ClassEditor/ClassEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class ClassList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      classes: [],
      schools: [],
      selectedSchool: props.schools[0].id
    }

    this.classUpdated = this.classUpdated.bind(this);
  }

  componentWillMount() {

    var schools = [];
    for(var j = 0; j < this.props.schools.length; j++) 
      schools.push({key: this.props.schools[j].id, label: this.props.schools[j].Name});

    this.setState({schools: schools});

    this.filterClasses(this.state.selectedSchool);
  }

  filterClasses(schoolID) {
    
    this.setState({selectedSchool: schoolID, classes: []}, function() {

      db.getClasses(this.state.selectedSchool).then(snapshot => {

        var classes = [];
        snapshot.forEach((doc) => {
  
            var classRoom = doc.data();
            classRoom.id = doc.id;
            if(!classRoom.Photos)
              classRoom.Photos = [];
            classes.splice(0, 0, classRoom);
  
            this.setState({classes: classes});
            this.props.onClassesLoaded(classes);      
        });
      });
    });
  }

  classUpdated() {
    this.filterClasses(this.state.selectedSchool);
  }

  visibleText(isVisible) {
    if(isVisible)
      return "Yes";
    else
      return "No";
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.allthingseq.com/classes");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Classes</h4>
                  <p className={classes.cardCategoryWhite}>
                    
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add Class"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                    >
                      <ClassEditor onChange={this.classUpdated} 
                        SchoolID={this.state.selectedSchool}
                        classroom={{
                          Name: "",
                          Description: "",
                          Photos: [],
                          orgId: this.props.org.id
                        }} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={false} sm={false} md={8}>
                    &nbsp;
                </GridItem>
                <GridItem xs={12} sm={12} md={4} >
                  <CustomSelect
                      labelText="School"
                      inputProps={{
                          placeholder: "Choose a School"
                      }}
                      formControlProps={{
                          fullWidth: true
                      }}
                      onChange={(e) => this.filterClasses(e.target.value)}
                      options={this.state.schools}
                      value={this.state.selectedSchool}
                    />
                </GridItem>
              </GridContainer>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                      <TableCell>

                      </TableCell>
                      <TableCell>
                        Name
                      </TableCell>
                      <TableCell>
                        Grade Level
                      </TableCell>
                      <TableCell>
                        Visible  
                      </TableCell>
                      <TableCell>
                          
                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.classes.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableActions}>
                        <Tooltip
                          id="tooltip-top"
                          title="Edit Class"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                         <ClassEditor classroom={value} onChange={this.classUpdated} SchoolID={this.state.selectedSchool.id} />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Name}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.GradeLevel}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {this.visibleText(value.IsVisible)}
                      </TableCell>
                      <TableCell className={classes.tableActions}>
                        <Tooltip
                          id="tooltip-top-start"
                          title="Remove Class"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                          <IconButton
                            aria-label="Close"
                            className={classes.tableActionButton}
                          >
                            <Close
                              className={
                                classes.tableActionButtonIcon + " " + classes.close
                              }
                            />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onClassesLoaded: ClassesLoaded }, dispatch);  
}

ClassList = connect(mapStateToProps, mapDispatchToProps)(ClassList);
export default withStyles(styles)(ClassList);



// WEBPACK FOOTER //
// ./src/views/ClassList/ClassList.jsx